export default __webpack_public_path__ + "static/media/taskamBg.ad54d69f.png";